// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../../common/image.res.js");

function DetailPane(props) {
  var analytics = props.analytics;
  var selectedEvent = props.selectedEvent;
  return JsxRuntime.jsxs("aside", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("img", {
                              className: "h-8 mr-2",
                              src: Image$ReactHooksTemplate.clipboard
                            }),
                        "Event Details"
                      ],
                      className: "p-4 border-b font-semibold text-lg flex items-center",
                      style: {
                        height: "80px"
                      }
                    }),
                JsxRuntime.jsx("div", {
                      children: selectedEvent !== undefined ? JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("p", {
                                      children: [
                                        JsxRuntime.jsx("strong", {
                                              children: "Source: "
                                            }),
                                        selectedEvent.source
                                      ]
                                    }),
                                JsxRuntime.jsxs("p", {
                                      children: [
                                        JsxRuntime.jsx("strong", {
                                              children: "Time: "
                                            }),
                                        selectedEvent.timestamp
                                      ]
                                    }),
                                JsxRuntime.jsxs("p", {
                                      children: [
                                        JsxRuntime.jsx("strong", {
                                              children: "Description: "
                                            }),
                                        selectedEvent.desc
                                      ]
                                    }),
                                JsxRuntime.jsxs("p", {
                                      children: [
                                        JsxRuntime.jsx("strong", {
                                              children: "Email: "
                                            }),
                                        selectedEvent.email
                                      ]
                                    }),
                                JsxRuntime.jsxs("p", {
                                      children: [
                                        JsxRuntime.jsx("strong", {
                                              children: "Phone: "
                                            }),
                                        selectedEvent.phone
                                      ]
                                    }),
                                JsxRuntime.jsxs("p", {
                                      children: [
                                        JsxRuntime.jsx("strong", {
                                              children: "Details: "
                                            }),
                                        selectedEvent.details
                                      ]
                                    })
                              ],
                              className: "space-y-2"
                            }) : JsxRuntime.jsx("p", {
                              children: "Select a timeline item to view details here."
                            }),
                      className: "overflow-y-auto p-4 text-sm space-y-3 text-gray-700",
                      style: {
                        height: "calc(100vh - 280px)"
                      }
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("img", {
                                      className: "h-8 mr-2",
                                      src: Image$ReactHooksTemplate.analytics
                                    }),
                                "Analytics"
                              ],
                              className: "text-md font-semibold mb-2 flex items-center"
                            }),
                        JsxRuntime.jsxs("ul", {
                              children: [
                                JsxRuntime.jsxs("li", {
                                      children: [
                                        JsxRuntime.jsx("strong", {
                                              children: "Total Orders: "
                                            }),
                                        String(analytics.totalOrders)
                                      ]
                                    }),
                                JsxRuntime.jsxs("li", {
                                      children: [
                                        JsxRuntime.jsx("strong", {
                                              children: "Avg. Resolution Time: "
                                            }),
                                        String(analytics.avgResolutionTime) + " hours"
                                      ]
                                    }),
                                JsxRuntime.jsxs("li", {
                                      children: [
                                        JsxRuntime.jsx("strong", {
                                              children: "Last Contacted Channel: "
                                            }),
                                        analytics.lastContactedChannel
                                      ]
                                    }),
                                JsxRuntime.jsxs("li", {
                                      children: [
                                        JsxRuntime.jsx("strong", {
                                              children: "Lifetime Value: "
                                            }),
                                        "$" + String(analytics.lifetimeValue)
                                      ]
                                    })
                              ],
                              className: "text-sm space-y-1 text-gray-700"
                            })
                      ],
                      className: "border-t p-4 bg-gray-50",
                      style: {
                        height: "200px"
                      }
                    })
              ],
              className: "w-1/4 bg-white border-l border-gray-200 flex flex-col",
              style: {
                height: "100vh"
              }
            });
}

var make = DetailPane;

exports.make = make;
/* react/jsx-runtime Not a pure module */
